import React, { useState, useEffect, useRef } from "react";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import { container } from "./styles.module.scss";
import cx from "classname";

const defaultOptions = {
  arrows: true,
  autoplay: false,
  pagination: false,
  type: "slide",
  perPage: 3,
  gap: 10,
  padding: 50,
  breakpoints: {
    960: {
      perPage: 1,
      pagination: true,
      arrows: false,
      padding: 0
    }
  }
};

export default React.forwardRef(function Slider(
  { children, options, className, ...otherProps },
  ref
) {
  const [isReady, setReady] = useState(false);
  const splide = useRef();

  useEffect(() => {
    async function init() {
      splide.current = await require("@splidejs/react-splide");
      setReady(true);
    }
    init();
  }, []);

  if (!isReady) {
    return null;
  }

  if (children.length === 1) {
    return children;
  }

  const Splide = splide.current.Splide;
  const SplideSlide = splide.current.SplideSlide;

  return (
    <div className={cx(container, className)}>
      <Splide options={options || defaultOptions} ref={ref} {...otherProps}>
        {children.map((child, i) => (
          <SplideSlide key={i}>{child}</SplideSlide>
        ))}
      </Splide>
    </div>
  );
});
